// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { onAuthStateChanged, getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, updatePhoneNumber, PhoneAuthProvider, updatePassword, getASecureRandomPassword, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import { getFirestore, collection, addDoc, query, where, getDocs, docs, updateDoc, doc, orderBy, Timestamp, arrayUnion, getDoc, setDoc, increment, decrement } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, list } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB55cOqgaLoGE5r8h6Nv0WA0xChsEPrUGw",
  authDomain: "bybabogados-138f2.firebaseapp.com",
  databaseURL: "https://bybabogados-138f2-default-rtdb.firebaseio.com",
  projectId: "bybabogados-138f2",
  storageBucket: "bybabogados-138f2.appspot.com",
  messagingSenderId: "253043047621",
  appId: "1:253043047621:web:ffbb017e62c54c54ef04ac",
  measurementId: "G-02BC1J6D2W"
};


// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
const db = getFirestore(firebase);
const analytics = getAnalytics(firebase);
const auth = getAuth(firebase);
const storage = getStorage(firebase);

//console.log(auth);


export { firebase, db, collection, addDoc, query, where, getDocs, getDoc, updateDoc, docs, doc, storage, ref, uploadBytesResumable, getDownloadURL, analytics, auth, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, updatePhoneNumber, EmailAuthProvider, PhoneAuthProvider, updatePassword, getASecureRandomPassword, reauthenticateWithCredential, list, orderBy, Timestamp, arrayUnion, setDoc, increment, decrement };